export const signupActionTypes = {
    //signup
    SIGNUP_REQUEST: 'SIGNUP_REQUEST',
    SIGNUP_SUCCESS: 'SIGNUP_SUCCESS',
    SIGNUP_FAILED: 'SIGNUP_FAILED',

};


// WEBPACK FOOTER //
// ./src/signup/actions/signup-action-types.js